import { array, bool, func, oneOfType, string } from 'prop-types'
import { AnalyticsConsumer } from '@opallabs/quanta'
import HotKey from '.'

function TrackedHotKey({ hotKey, callback, overrideBrowser = false }) {
  const createTrackedCallback = (track) => (e) => {
    if (typeof track === 'function') {
      track('hotkey', { value: hotKey })
    }
    callback(e)
  }

  return (
    <AnalyticsConsumer>
      {({ track }) => (
        <HotKey
          hotKey={hotKey}
          callback={createTrackedCallback(track)}
          overrideBrowser={overrideBrowser}
        />
      )}
    </AnalyticsConsumer>
  )
}

TrackedHotKey.propTypes = {
  callback: func.isRequired,
  hotKey: oneOfType([array, string]).isRequired,
  overrideBrowser: bool,
}

export default TrackedHotKey
